import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import $ from 'jquery';
import { slugify } from 'transliteration/dist/browser/bundle.esm.min';
// ACTIONS
import * as bysideActions from './actions/byside.actions';
//VIEWS
import Main from './views/main';
import Waiting from './views/waiting-call';
import UnavailableService from './views/unavailable-service';

const BysideContainer = props => {
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const plan = parseInt(params.get('plano'));
    const productOrigin = params.get('productOrigin');
    const _additional = params.get('adicional');
    const additional = (_additional && _additional.replace(/\s/g, '+')) || null;
    const city = slugify(params.get('cidade'));

    if (!plan || !productOrigin || !city) {
      window.location.href = 'http://www.oi.com.br';
    } else if (plan && productOrigin && city) {
      props.actions.loadProduct({
        plan: plan,
        productOrigin: productOrigin,
        additional: additional,
        city: city,
      });
    }
  }, []);

  useEffect(() => {
    const { OiDatalayer = {} } = document;
    try {
      const {
        byside: {
          ui: {
            product: { datalayer },
          },
        },
      } = props;
      OiDatalayer.page = {
        pageType: 'checkout-c2c',
        product: [datalayer],
      };
    } catch (e) {
      console.error(e);
    }
  }, [props.byside]);

  const [changeAwaitScreen, setChangeAwaitScreen] = useState(false);
  const [serviceUnavailable, setServiceUnavailable] = useState(false);

  useEffect(() => {
    $('body').on('DOMSubtreeModified', '.call_progress_msg', function() {
      const actionText = $('.call_progress_msg')
        .children()
        .text();
      if (actionText === 'Ligando') {
        setChangeAwaitScreen(true);
        setServiceUnavailable(false);
        setInterval(() => {
          window.location.assign('https://oi.com.br');
        }, 5000);
      }
    });
  });

  const bboErrorCheckInterval = setInterval(() => {
    const elements = document.getElementsByClassName('bbo_error');
    if (elements.length > 0) {
      handleMutationObservation(elements[0]);
    }
  });

  const ui = props.byside.ui;

  const handleMutationObservation = el => {
    clearInterval(bboErrorCheckInterval);

    // Select the node that will be observed for mutations
    let targetNode = el;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: false, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          setServiceUnavailable(true);
          setChangeAwaitScreen(false);
          setInterval(() => {
            window.location.assign('https://oi.com.br');
          }, 5000);
          break; // Jump out of the loop since we detected the desired mutation
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  };

  if (changeAwaitScreen) {
    return <Waiting product={ui.product} />;
  } else if (serviceUnavailable) {
    return <UnavailableService />;
  } else {
    return <Main ui={ui} />;
  }
};

BysideContainer.propTypes = {
  byside: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = state => ({
  byside: state.byside,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(bysideActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BysideContainer);
